<template>
  <div class="casco-letter">
    <LetterLayout
      :model="model"
      hide-to
      hide-date
      :signature-margin-line-count="0"
      @ready="$emit('ready')"
    >
      <template #from>
        <header class="casco-letterhead">
          <img :src="logo" alt="Casco — Rooted in what matters" />
        </header>
      </template>
      <template #subject>
        <h1>Short-Term Rental (STR) Registration Renewal Reminder</h1>
      </template>

      <p>Dear {{ model.ownerFormatted }},</p>
      <p>
        This letter is a friendly reminder that the Short-Term Rental (STR) registration application fee
        must be paid annually to maintain your registration.
      </p>
      <p>
        Please note that STR registrations are valid for the calendar year only and must be renewed
        each year. The annual registration fee is $100.00.
        <template v-if="model.license?.expirationDateFormatted">
          Your STR license expires on {{ model.license.expirationDateFormatted }}, and your renewal
          payment is due by that date.
        </template>
        <template v-else>
          Your renewal payment is due by the new year.
        </template>
      </p>
      <p>Payment may be made by mailing a check for $100.00 payable to Town of Casco.</p>
      <p>
        Please include “STR and your property address” in the memo line of your check to ensure your
        payment is properly identified.
      </p>
      <p>Please mail your payment to:</p>
      <p>
        Town of Casco<br/>
        635 Meadow Rd, Casco ME 04015
      </p>
      <p>If you have any questions regarding the renewal process or payment, please contact:</p>
      <p>
        Devin Langadas<br/>
        Email: <a href="mailto:dlangadas@cascomaine.org">dlangadas@cascomaine.org</a><br/>
        Phone: 207-627-1346
      </p>
      <p>
        Thank you for your attention to this matter and for your cooperation with the Town of Casco.
      </p>
      <template #signature>
        <p>
          Sincerely,<br/>
          Devin Langadas, Deputy Code Enforcement Officer
        </p>
      </template>
      <template #footer>
        <footer class="casco-footer">
          <div>Phone (207) 627-4515</div>
          <div>
            635 Meadow Road<br/>
            Casco, Maine 04015<br/>
            www.cascomaine.org
          </div>
          <div>Fax (207) 803-1250</div>
        </footer>
      </template>
    </LetterLayout>
  </div>
</template>

<script>
import LetterLayout from "@/components/letters/LetterLayout.vue";
import {LetterContext} from "@/models/letterContext";
import logo from './casco-logo.png';

export default {
  components: {LetterLayout},
  props: {
    model: LetterContext
  },
  emits: ['ready'],
  data() {
    return { logo };
  }
}
</script>

<style scoped>
.casco-letter {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 7.5in;
  min-height: 10in;
  margin: 0 auto;
  padding: 0 0.5in;
  color: #000;
  font-family: "Times New Roman", Times, serif;
  font-size: 12pt;
  line-height: 1.16;
}

.casco-letter :deep(.letter) {
  min-height: auto;
  margin: 0;
  padding: 0 !important;
  gap: 0 !important;
  font-size: inherit;
  line-height: inherit;
}

.casco-letter :deep(.print-footer) {
  position: static;
  width: auto;
  height: auto;
  margin: auto 0 0 !important;
  padding-top: 0.3in;
}

.casco-letterhead {
  margin: 0 0 0.4in 0;
}

.casco-letterhead img {
  display: block;
  width: 2.28in;
  height: auto;
}

.casco-letter h1,
.casco-letter p {
  margin: 0 0 8pt;
  font-size: inherit;
  line-height: inherit;
}

.casco-letter h1 {
  font-weight: bold;
}

.casco-letter a {
  color: #467886;
  text-decoration: underline;
}

.casco-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8pt;
  font: italic 11pt/1.16 Arial, sans-serif;
  text-align: center;
}

.casco-letter p,
.casco-footer {
  break-inside: avoid;
}

@media print {
  @page casco-letter {
    size: letter;
    margin: 0.5in;
  }

  .casco-letter {
    page: casco-letter;
  }
}
</style>
